var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPay01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1410_45923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8434 70.7171H21.2512C20.9062 70.7171 20.5785 70.5805 20.337 70.3416L11.3795 61.4839C11.138 61.245 11 60.9207 11 60.5794V25.1316C11 24.4261 11.5807 23.8516 12.2936 23.8516H50.8434C51.5563 23.8516 52.137 24.4261 52.137 25.1316V69.437C52.137 70.1425 51.5563 70.7171 50.8434 70.7171ZM21.7859 68.157H49.5498V26.4116H13.5872V60.0503L21.7859 68.1627V68.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2511 70.7165C20.9119 70.7165 20.5842 70.5857 20.337 70.3411L11.3794 61.4834C11.0115 61.1193 10.8965 60.5675 11.0977 60.0896C11.2989 59.6117 11.7704 59.2988 12.2936 59.2988H21.2511C21.9641 59.2988 22.5448 59.8734 22.5448 60.5788V69.4365C22.5448 69.9542 22.2285 70.4207 21.7456 70.6198C21.5846 70.6881 21.4179 70.7165 21.2511 70.7165ZM15.4155 61.8589L19.9518 66.3474V61.8589H15.4155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0814 36.0483H21.0558C20.3429 36.0483 19.7622 35.4737 19.7622 34.7683C19.7622 34.0629 20.3429 33.4883 21.0558 33.4883H42.0814C42.7943 33.4883 43.375 34.0629 43.375 34.7683C43.375 35.4737 42.7943 36.0483 42.0814 36.0483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0814 44.394H21.0558C20.3429 44.394 19.7622 43.8194 19.7622 43.114C19.7622 42.4086 20.3429 41.834 21.0558 41.834H42.0814C42.7943 41.834 43.375 42.4086 43.375 43.114C43.375 43.8194 42.7943 44.394 42.0814 44.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0814 52.7339H21.0558C20.3429 52.7339 19.7622 52.1593 19.7622 51.4538C19.7622 50.7484 20.3429 50.1738 21.0558 50.1738H42.0814C42.7943 50.1738 43.375 50.7484 43.375 51.4538C43.375 52.1593 42.7943 52.7339 42.0814 52.7339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0813 61.0796H28.4667C27.7538 61.0796 27.1731 60.505 27.1731 59.7995C27.1731 59.0941 27.7538 58.5195 28.4667 58.5195H42.0813C42.7942 58.5195 43.3749 59.0941 43.3749 59.7995C43.3749 60.505 42.7942 61.0796 42.0813 61.0796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8871 58.5823H67.7062C68.4191 58.5823 68.9998 58.0077 68.9998 57.3023V12.9968C68.9998 12.2914 68.4191 11.7168 67.7062 11.7168H29.1564C28.4435 11.7168 27.8628 12.2914 27.8628 12.9968V26.0454H30.45V14.2768H66.4126V56.0223H51.8871V58.5823Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1410_45923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 59,
    fill: "white",
    transform: "translate(11 11.7168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPay01);
export default __webpack_public_path__ + "static/media/icon_pay01.42669f7e1f40476e98108629be9b8272.svg";
export { ForwardRef as ReactComponent };